<div class="seg-insp-page">
  <header class="seg-insp-header">
    <div>
      <h1>Segment Inspection</h1>
      <p>Supervisor document verification → L1 engineer nomination → geo-tagged site inspection</p>
    </div>
    <button mat-raised-button color="primary" routerLink="/home/segment-inspection/new">
      <mat-icon>add</mat-icon> New segment inspection
    </button>
  </header>

  <div class="seg-insp-toolbar">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search</mat-label>
      <input matInput (input)="applyFilter($event)" placeholder="Project, segment, engineer..." />
      <mat-icon matPrefix>search</mat-icon>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Status</mat-label>
      <mat-select [(value)]="statusFilter" (selectionChange)="load()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let s of statusLabels | keyvalue" [value]="s.key">{{ s.value }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-checkbox [(ngModel)]="showMyAssignments" (change)="load()">My assignments</mat-checkbox>
  </div>

  <div class="seg-insp-table-wrap">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="srNo">
        <th mat-header-cell *matHeaderCellDef>#</th>
        <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
      </ng-container>

      <ng-container matColumnDef="project">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Project</th>
        <td mat-cell *matCellDef="let row">
          <div class="cell-title">{{ row.project_name }}</div>
          <div class="cell-sub" *ngIf="row.project_identifier">{{ row.project_identifier }}</div>
        </td>
      </ng-container>

      <ng-container matColumnDef="segment">
        <th mat-header-cell *matHeaderCellDef>Segment</th>
        <td mat-cell *matCellDef="let row">{{ segmentLabel(row) }}</td>
      </ng-container>

      <ng-container matColumnDef="plannedDate">
        <th mat-header-cell *matHeaderCellDef>Planned date</th>
        <td mat-cell *matCellDef="let row">{{ row.planned_inspection_date | date:'mediumDate' }}</td>
      </ng-container>

      <ng-container matColumnDef="engineer">
        <th mat-header-cell *matHeaderCellDef>Engineer</th>
        <td mat-cell *matCellDef="let row">{{ row.inspection_engineer_name || '—' }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <span class="status-pill" [ngClass]="statusClass(row.status)">
            {{ statusLabels[row.status] || row.status }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let row">
          <button mat-icon-button color="primary" (click)="openDetail(row)" matTooltip="Open workflow">
            <mat-icon>open_in_new</mat-icon>
          </button>
          <button mat-icon-button color="warn" (click)="deleteRow(row)" matTooltip="Delete">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="clickable-row" (click)="openDetail(row)"></tr>
    </table>

    <p *ngIf="!dataSource.data.length" class="empty-msg">No segment inspections yet.</p>
    <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons></mat-paginator>
  </div>
</div>
